import { FeatureFlags } from 'types/storefront';

export const DEFAULT_STORE_PAUSE_MESSAGE =
  'Podés recorrer el catálogo, pero los pedidos están suspendidos por el momento.';

export const isStorePaused = (features: FeatureFlags) => Boolean(features.storePaused);

export const storePauseMessage = (
  features: Pick<FeatureFlags, 'storePausedMessage'>,
  fallback = DEFAULT_STORE_PAUSE_MESSAGE
) => {
  const custom = features.storePausedMessage?.trim();
  return custom || fallback;
};
